import { useState, useCallback } from 'react';

export type D214Mode = 'browse' | 'add' | 'edit';

export function useD214Mode() {
  const [mode, setMode] = useState<D214Mode>('browse');

  const toBrowse = useCallback(() => setMode('browse'), []);
  const toAdd = useCallback(() => setMode('add'), []);
  const toEdit = useCallback(() => setMode('edit'), []);

  const isEditing = mode === 'add' || mode === 'edit';

  return { mode, setMode, toBrowse, toAdd, toEdit, isEditing };
}
